import React from 'react';
import useCan from './useCan';
import type { Permission } from '@/permissions_manifest.generated';

interface CanShowProps {
  requiredPermission: Permission;
  children: React.ReactNode;
}

/**
 * <CanShow> — 有權限才 render，沒權限完全不出現
 *
 * 用於 dropdown menu item、次要 action 等「沒權限就不該看到」的情境。
 * 主畫面 button 請改用 <Can>（disabled + 鎖頭）。
 *
 * 用法：
 *   <CanShow requiredPermission="orders:write">
 *     <Menu.Item>Duplicate</Menu.Item>
 *   </CanShow>
 */
const CanShow: React.FC<CanShowProps> = ({ requiredPermission, children }) => {
  const can = useCan();
  return can(requiredPermission) ? <>{children}</> : null;
};

export default CanShow;
